<template>
  <div class="mt-4 mb-16">
    <div class="shadow overflow-hidden rounded border-b border-gray-200">
      <table class="min-w-full bg-white">
        <thead class="bg-gray-800 text-white">
        <tr>
          <th class="w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Zusammenfassung </th>
          <th class="w-2/3 text-left py-3 px-4 uppercase font-semibold text-sm">Test vom {{ moment(test.created_at).format('DD.MM.YYYY HH:mm') }}</th>
        </tr>
        </thead>
        <tbody class="text-gray-700">
        <tr>
          <td class="w-1/w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Bestanden</td>
          <td class="w-2/3 text-left py-3 px-4" :class="(results.outcome) ? 'text-success-500' : 'text-red-500'">{{ __(`general.${results.outcome}` ) }}</td>
        </tr>

        <tr class="bg-gray-200">
          <td class="w-1/w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Prüfungsdauer</td>
          <td class="w-2/3 text-left py-3 px-4">{{ test.estimated_time }} Minute{{ ( test.estimated_time > 1 ) ? 'n' : '' }}</td>
        </tr>

        <tr>
          <td class="w-1/w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Richtige Antwort</td>
          <td class="w-2/3 text-left py-3 px-4">{{ results.answered_right.length }}</td>
        </tr>

        <tr>
          <td class="w-1/w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Falsche Antwort</td>
          <td class="w-2/3 text-left py-3 px-4">{{ results.answered_wrong.length }}</td>
        </tr>

        <tr>
          <td class="w-1/w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Richtige Antworten in %</td>
          <td class="w-2/3 text-left py-3 px-4">{{ results.percentage }}%</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TestResultTable',

  props: {
    results: {
      type: Array,
      required: true,
    },
    test: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moment: moment,
    }
  },
}
</script>

<style scoped>

</style>